// useSidebarBucketsData.js

import { useEffect, useState } from 'react';

// Services
import { subscribeToCollectionsShared } from 'services/collections';
import { subscribeToDashboards } from 'services/dashboards/DashboardReadService';

/**
 * Subscribes sidebar bucket source rows for the active base.
 *
 * @param {string} baseKey - Active base key (wire: baseKey).
 * @returns {object} Collections and dashboards for sidebar bucket composition.
 */
const useSidebarBucketsData = ({ baseKey }) => {
    const [databases, setDatabases] = useState([]);
    const [dashboards, setDashboards] = useState([]);

    useEffect(() => {
        if (!baseKey) {
            setDatabases([]);
            return undefined;
        }

        const unsubscribe = subscribeToCollectionsShared(baseKey, (rows) => {
            setDatabases(Array.isArray(rows) ? rows : []);
        });

        return () => unsubscribe?.();
    }, [baseKey]);

    useEffect(() => {
        if (!baseKey) {
            setDashboards([]);
            return undefined;
        }

        const unsubscribe = subscribeToDashboards(baseKey, (rows) => {
            setDashboards(Array.isArray(rows) ? rows : []);
        }, { scope: 'GLOBAL' });

        return () => unsubscribe?.();
    }, [baseKey]);

    return {
        databases,
        dashboards,
    };
};

export default useSidebarBucketsData;
